<template>
	<v-container fluid class="ma-0 pa-0">
    <StoreHeader />
    <v-row class="ma-0 pa-0">
      <LeftStoreDetailNav />
			<v-col class="ma-0 pa-0" cols="10">
				<v-col id="header" class="ma-0 pa-0" cols="12">
					<v-col class="ma-0" cols="12" id="header_body">
						<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
							<v-row class="ma-0 pa-4 pl-0 pr-0" align="center" justify="space-between">
								<v-col class="ma-0 pa-0" cols="auto">
									<v-row class="ma-0 pa-0" align="center">
										<v-btn width="9rem" height="auto" class="back_clean_btn ma-0 pa-2 current_tap_btn" 
											elevation="0">
											{{ta('numberOfCustomers')}}
										</v-btn>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-row class="ma-0 pa-0" align="center">
										<v-col class="ma-0 pa-0 pr-2" cols="auto">{{ta('period')}}:</v-col>
										<v-col class="ma-0 pa-0 mr-4" cols="auto" style="width:14rem;">
											<v-select background-color="#272727" dark v-model="period"
												:items="periodList" hide-details outlined :height="30"
												item-text="label" item-value="value" 
												:class="{'select_font': fromToString != ''}"
											></v-select>
										</v-col>
										<v-col class="ma-0 pa-0 pr-2" cols="auto">{{ta('mode')}}:</v-col>
										<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
											<v-select background-color="#272727" dark v-model="mode"
												:items="modeList" dense hide-details outlined
												item-text="label" item-value="value"
											></v-select>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<AnalyticsDatePicker :mode="mode" :leftSide="leftSide" :num="axisNum"
								:period="period"
								:start="startDate" :end="endDate" @update="onAxisUpdated" />
						</v-col>
					</v-col>
				</v-col>
        <v-col class="pa-0 pb-10" id="main_content_maxwidthset" cols="12"
					style="font-weight:bold;">
					<AnalyticsWeather v-if="weatherVisible"
						:weatherLoading="weatherLoading" :mode="mode"
						:axisNum="axisNum" :weatherDate="weatherDate" />

          <AnalyticsBox :mode="mode" :period="period" :downloadMode="downloadMode"
                        :downloadPeriod="downloadPeriod" :startDate="startDate"
                        :endDate="endDate" :leftSide="leftSide" :params="params"
                        :axisNum="axisNum" :unisCustomerCd="unisCustomerCd" />
				</v-col>
				<FromToDatePickerDialog :dialogVisible="fromToDialogVisible"
					@visible="fromToDialogVisibleFunc" @fromtoEvent="fromtoEventFunc"
					@cancel="fromToCancelFunc" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import analyticsMixin from '@/mixin/analytics.js';
import StoreHeader from './components/StoreHeader.vue';
import LeftStoreDetailNav from './components/LeftStoreDetailNav.vue';
import AnalyticsDatePicker from '@/views/all-store/AnalyticsDatePicker.vue';
import FromToDatePickerDialog from '@/components/dialogs/FromToDatePicker.vue';
import AnalyticsWeather from '@/components/AnalyticsWeather.vue';
import AnalyticsBox from '@/components/AnalyticsBox.vue';

export default {
  components: {
    AnalyticsBox,
    StoreHeader, LeftStoreDetailNav, AnalyticsDatePicker, AnalyticsWeather,
    FromToDatePickerDialog
  },
  mixins: [mixin.common, analyticsMixin],
  data: () => ({
    deviceStatusLoading: false,
    role: '',
    authorities: {},
    storeCnt: 0,
    currentRoute: '',
    unisCustomerCd: '',
    areaCd: undefined,
    leftSide: {},
    period: '7day',
    mode: 'day',
    fromToDialogVisible: false,
    fromDate: null,
    toDate: null,
    fromToString: '',
    fromtoEdit: false,
    diff: 7,
    pageName: 'storeAnalyze',
    fileDownloadData: {},
    downloadMode: '',
    downloadPeriod: '',
    fileDownloadLink: '',
    modeText: '日別',
    fileDownloadFrom: '', //파일 다운로드 기간 from
    fileDownloadTo: '', //파일 다운로드 기간 to
    periodText: '日別',
    weatherLoading: false,
    weatherArray: [],
    weatherDate: [],
    weatherVisible: true,
    params: { from: '', to: '' },
  }),
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.currentRoute = to.name;
      }
    },
    mode: function (item) {
      this.leftSide = this.getInitialLeftSide(this.axisNum - 1);
      this.downloadMode = item;
      console.log('from- ', this.getFromDateValue(this.leftSide, item));
      console.log('to- ', this.getToDateValue(this.leftSide, item));
      this.params.from = this.getFromDateValue(this.leftSide, item);
      this.params.to = this.getToDateValue(this.leftSide, item);
    },
    period(item) {
      if (item == 'fromto') {
        this.fromToDialogVisible = true;
        this.mode = this.modeType.HOUR;
      } else if (item == 'fromtoRetry') {
        this.$nextTick(() => {
          this.fromDate = null;
          this.toDate = null;
          this.fromToString = '';
          this.fromtoEdit = false;
          this.period = 'fromto';
          this.mode = this.modeType.HOUR;
        })
      } else {
        if (item == 'today') {
          let today = new Date();
          this.mode = this.modeType.HOUR;
          let from = new Date();
          let setfrom = new Date(from.setDate(from.getDate() - 1));
          this.fromDate = this.getDateHourStr(setfrom);
          this.toDate = this.getDateHourStr(today);
        } else if (item == '7day') {
          this.mode = this.modeType.DAY;
          let from = new Date();
          let from7day = new Date(from.setDate(from.getDate() - 6));
          let to = new Date();
          this.fromDate = this.getDateHourStr(from7day);
          this.toDate = this.getDateHourStr(to);
        } else { // 30day
          this.mode = this.modeType.DAY;
          let from = new Date();
          let from30day = new Date(from.setDate(from.getDate() - 29));
          let to = new Date();
          this.fromDate = this.getDateHourStr(from30day);
          this.toDate = this.getDateHourStr(to);
        }
        this.fromToString = '';
        this.leftSide = this.getInitialLeftSide(this.axisNum - 1);
        console.log('leftSide- ', this.leftSide);
        console.log('from- ', this.getFromDateValue(this.leftSide, this.mode));
        console.log('to- ', this.getToDateValue(this.leftSide, this.mode));
        this.params.from = this.getFromDateValue(this.leftSide, this.mode);
        this.params.to = this.getToDateValue(this.leftSide, this.mode);
        this.downloadPeriod = item;
      }
    },
    params: {
      deep: true,
      handler(val, oldVal) {
        // this.fetchVisitorData();
        this.checkModeFetchWeatherData();
      }
    },
  },
  computed: {
    modeType: function () {
      return this.$store.state.analyticsModeType;
    },
    periodList() {
      if (this.fromToString == '') {
        return [
          { label: '本日', value: 'today' },
          { label: '最新の7日間', value: '7day' },
          // { label: '最新の30日間', value: '30day' },
          {
            label: this.fromToString == '' ? this.$i18n.t('lang.common.periodSetting')
              : this.fromToString, value: 'fromto'
          },
        ]
      } else {
        return [
          { label: '本日', value: 'today' },
          { label: '最新の7日間', value: '7day' },
          // { label: '最新の30日間', value: '30day' },
          {
            label: this.fromToString == '' ? this.$i18n.t('lang.common.periodSetting')
              : this.fromToString, value: 'fromto'
          },
          { label: this.$i18n.t('lang.common.periodSetting'), value: 'fromtoRetry' },
        ]
      }
    },
    modeList() {
      if (this.period == 'today') {
        return [
          { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
        ]
      } else if (this.period == '7day') {
        return [
          { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
          { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
        ]
      } else if (this.period == '30day') {
        return [
          { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
          { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
          { label: this.$i18n.t('lang.allStoreAnalytics.week'), value: this.modeType.WEEK },
        ]
      } else if (this.period == 'fromto') {
        if (this.diff < 14) {
          return [
            { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
            { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
          ]
        } else if (this.diff >= 14 && this.diff < 60) {
          return [
            { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
            { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
            { label: this.$i18n.t('lang.allStoreAnalytics.week'), value: this.modeType.WEEK },
          ]
        } else if (this.diff >= 60 && this.diff < 180) {
          return [
            { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
            { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
            { label: this.$i18n.t('lang.allStoreAnalytics.week'), value: this.modeType.WEEK },
            { label: this.$i18n.t('lang.allStoreAnalytics.month'), value: this.modeType.MONTH },
          ]
        } else {
          return [
            { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
            { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
            { label: this.$i18n.t('lang.allStoreAnalytics.week'), value: this.modeType.WEEK },
            { label: this.$i18n.t('lang.allStoreAnalytics.month'), value: this.modeType.MONTH },
            { label: '3' + this.$i18n.t('lang.allStoreAnalytics.month'), value: this.modeType.THREE },
          ]
        }
      } else {
        return [
          { label: this.$i18n.t('lang.allStoreAnalytics.hourly'), value: this.modeType.HOUR },
          { label: this.$i18n.t('lang.allStoreAnalytics.daily'), value: this.modeType.DAY },
          { label: this.$i18n.t('lang.allStoreAnalytics.week'), value: this.modeType.WEEK },
          { label: this.$i18n.t('lang.allStoreAnalytics.month'), value: this.modeType.MONTH },
          { label: '3' + this.$i18n.t('lang.allStoreAnalytics.month'), value: this.modeType.THREE },
        ]
      }
    },
    today: function () {
      return this.getDateObj(new Date());
    },
    axisNum: function () {
      if (this.period == '7day') {
        switch (this.mode) {
          case this.modeType.HOUR:
            return 10;
          case this.modeType.DAY:
            return 7;
          case this.modeType.WEEK:
            return 6;
          case this.modeType.MONTH:
            return 10;
          case this.modeType.THREE:
            return 6;
          default:
            return 0;
        }
      } else {
        switch (this.mode) {
          case this.modeType.HOUR:
            return 10;
          case this.modeType.DAY:
            return 10;
          case this.modeType.WEEK:
            return 6;
          case this.modeType.MONTH:
            return 10;
          case this.modeType.THREE:
            return 6;
          default:
            return 0;
        }
      }
    },
    startDate: function () {
      const fromDate = this.fromDate; // 20221025
      if (fromDate == null) {
        return null
      } else {
        const startDate = this.getDate(fromDate);
        return {
          year: startDate.getFullYear(),
          month: startDate.getMonth() + 1,
          date: startDate.getDate(),
          hour: startDate.getHours(),
        }
      }
    },
    endDate: function () {
      const date = this.getDate(this.today);
      const toDate = this.toDate; // 20221101
      let endDate;
      if (toDate == null) {
        switch (this.mode) {
          case this.modeType.HOUR:
            endDate = date;
            break;
          case this.modeType.DAY:
            endDate = date;
            break;
          case this.modeType.WEEK:
            endDate = this.getFirstDateOfWeek(date);
            break;
          case this.modeType.MONTH:
            endDate = date;
            break;
          case this.modeType.THREE:
            endDate = this.getFirstMonthOfThree(date);
            break;
          default:
            break;
        }
      } else {
        endDate = this.getDate(toDate);
      } 
      if (this.startDate && endDate) {
        const isSameDate = this.startDate.year === endDate.getFullYear() 
          && this.startDate.month === endDate.getMonth() + 1 
          && this.startDate.date === endDate.getDate();
        if (isSameDate) endDate.setHours(23);
      }
      return {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
        date: endDate.getDate(),
        hour: endDate.getHours(),
      }
    }
  },
  created() {
    this.role = this.roleCheck(this.$store.getters.getRole);
    this.authorities = this.$store.getters.getAuthorities;
    this.unisCustomerCd = this.$route.query.unisCustomerCd;
    let from = new Date();
    let from7day = new Date(from.setDate(from.getDate() - 6));
    let to = new Date();
    this.fromDate = this.getDateHourStr(from7day);
    this.toDate = this.getDateHourStr(to);
    this.leftSide = this.getInitialLeftSide(this.axisNum - 1);
    this.downloadMode = this.modeType.DAY;
    this.downloadPeriod = '7day';
    console.log('leftSide- ', this.leftSide);
    console.log('from- ', this.getFromDateValue(this.leftSide, this.mode));
    console.log('to- ', this.getToDateValue(this.leftSide, this.mode));
    this.params.from = this.getFromDateValue(this.leftSide, this.mode);
    this.params.to = this.getToDateValue(this.leftSide, this.mode);
  },
  mounted() {
    let storeData = this.$store.getters.getStoreData;
    this.areaCd = storeData.areaCd;

    if (this.currentRoute != 'storeAnalyze') this.getDeviceStatus();
    if (this.currentRoute == 'storeAnalyze') {
      const element = document.getElementById('header');
      element.style.top = '50px';
    }
  },
  methods: {
    ta(t) {
      return this.$t("lang.allStoreAnalytics." + t);
    },
    async getDeviceStatus() {
      this.deviceStatusLoading = true;
      await this.networkController.getDashboardDeviceStatusData({})
        .then(async (res) => {
          this.storeCnt = res.data.storeCnt;
          this.deviceStatusLoading = false;
        }).catch(error => {
          this.deviceStatusLoading = false;
        });
    },
    getInitialLeftSide(offset) {
      const date = this.getDate(this.today);
      const fromDate = this.fromDate;
      let leftSideDate;
      let firstDateOfWeek;
      let firstMonthOfThree;

      if (fromDate == null) {
        switch (this.mode) {
          case this.modeType.HOUR:
            date.setHours(date.getHours() - offset);
            leftSideDate = date;
            break;
          case this.modeType.DAY:
            date.setDate(date.getDate() - offset);
            leftSideDate = date;
            break;
          case this.modeType.WEEK:
            firstDateOfWeek = this.getFirstDateOfWeek(date);
            firstDateOfWeek.setDate(firstDateOfWeek.getDate() - offset * 7);
            leftSideDate = firstDateOfWeek;
            break;
          case this.modeType.MONTH:
            date.setMonth(date.getMonth() - offset);
            leftSideDate = date;
            break;
          case this.modeType.THREE:
            firstMonthOfThree = this.getFirstMonthOfThree(date);
            firstMonthOfThree.setMonth(firstMonthOfThree.getMonth() - offset * 3);
            leftSideDate = firstMonthOfThree;
            break;
          default:
            break;
        }
      } else {
        leftSideDate = this.getDate(fromDate);
      }
      return {
        year: leftSideDate.getFullYear(),
        month: leftSideDate.getMonth() + 1,
        date: leftSideDate.getDate(),
        hour: leftSideDate.getHours(),
      }
    },
    onAxisUpdated: function (e) {
      this.leftSide = e.date;
      console.log('leftSide- ', e.date);
      console.log('from- ', this.getFromDateValue(e.date, this.mode));
      console.log('to- ', this.getToDateValue(e.date, this.mode));
      this.params.from = this.getFromDateValue(e.date, this.mode);
      this.params.to = this.getToDateValue(e.date, this.mode);
    },
    fromToDialogVisibleFunc(visible) {
      this.fromToDialogVisible = visible;
    },
    fromToCancelFunc(status) {
      if (status) {
        this.$nextTick(() => {
          this.period = 'today';
          this.mode = this.modeType.HOUR;
        })
      }
    },
    fromtoEventFunc(data) {
      this.mode = data.mode;
      this.fromDate = data.from;
      this.toDate = data.to;
      this.fromToString = data.from.substring(0, 4) + '/' + data.from.substring(4, 6) + '/' + data.from.substring(6, 8) + '-'
        + data.to.substring(0, 4) + '/' + data.to.substring(4, 6) + '/' + data.to.substring(6, 8);
      this.fromtoEdit = data.fromtoEdit;
      this.leftSide = this.getInitialLeftSide(this.axisNum - 1);
      console.log('leftSide- ', this.leftSide);
      console.log('from- ', this.getFromDateValue(this.leftSide, this.mode));
      console.log('to- ', this.getToDateValue(this.leftSide, this.mode));

      const from = this.getDate(data.from);
      const to = this.getDate(data.to);
      const diffsecond = this.calculateBetweenTwoDate(from, to)
      this.diff = Math.abs(diffsecond / (60 * 60 * 24)); // 단위 1일(day)
      this.downloadPeriod = 'fromto';
    },
  }
}
</script>

<style lang="scss" scoped>
#header {
  position: sticky;
  top: 0;
  z-index: 5;
}
#head_title {
  background-color: #272a33;
  z-index: 6;
}
#header_height {
  height: 50px;
}
#header_body {
  background-color: #222222;
}
.current_tap_btn {
  color: white !important;
  border-bottom: 3px solid #008dd0 !important;
}
.v-list {
  background: #171921 !important;
  border: 1px solid #4a4a4a;
}
::v-deep {
  .v-list-item__content {
    color: white;
  }
  // Select box v화살표 위치
  .v-input__slot {
    padding-right: 2px !important;
  }
  .v-input__append-inner {
    margin-top: 16px !important;
    padding-left: 0px !important;
  }
  // Select Box Height 설정
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 35px !important;
  }
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control {
    height: 35px;
  }
}
.back_clean_btn {
  color: #979fb1;
  // border-bottom: 1px solid #008DD0;
  border-bottom: 1px solid #484848;
  background-color: transparent !important;
  min-width: 1rem;
}
.back_clean_btn {
  color: #979fb1;
  // border-bottom: 1px solid #008DD0;
  border-bottom: 1px solid #484848;
  background-color: transparent !important;
  min-width: 1rem;
}
.current_tap_btn {
  color: white !important;
  border-bottom: 3px solid #008dd0 !important;
}
.v-list {
  background: #171921;
  border: 1px solid #4a4a4a;
}
::v-deep {
  .v-list-item__content {
    color: white;
    text-align: left;
  }
  // Select box v화살표 위치
  .v-input__slot {
    padding-right: 2px !important;
  }
  .v-input__append-inner {
    margin-top: 16px !important;
    padding-left: 0px !important;
  }
  // Select Box Height 설정
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 35px !important;
  }
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control {
    height: 35px;
  }
  .modeText {
    color: #979797;
    text-align: left;
  }
  .progress_circle {
    position: absolute;
    top: -3rem;
    right: 5.5rem;
    height: 8rem;
  }
}
.temp {
  font-size: 0.75rem;
}
.select_font {
  ::v-deep {
    .v-select__selection--comma {
      text-overflow: clip !important;
      white-space: normal !important;
      font-size: 0.8rem;
    }
  }
}
</style>